import { Fight } from '../../domain/models/fight.model';
import {
  RetrieveFights,
  RetrieveFightsFailure,
  RetrieveFightsPayload,
  RetrieveFightsSuccess,
  RETRIEVE_FIGHTS,
  RETRIEVE_FIGHTS_FAILURE,
  RETRIEVE_FIGHTS_SUCCESS,
} from './fight.action.type';

export const retrieveFights = (
  payload: RetrieveFightsPayload,
): RetrieveFights => ({
  type: RETRIEVE_FIGHTS,
  payload,
});

export const retrieveFightsSuccess = (
  payload: Fight[],
): RetrieveFightsSuccess => ({
  type: RETRIEVE_FIGHTS_SUCCESS,
  payload,
});

export const retrieveFightsFailure = (
  error: string,
): RetrieveFightsFailure => ({
  type: RETRIEVE_FIGHTS_FAILURE,
  payload: error,
});
